<template>
  <!--
      	作者：zhuchangtao
      	时间：2020-12-30
      	描述：插件中心-素材
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="素材管理" name="material">
                    <Material v-if="activeName=='material'"></Material>
                </el-tab-pane>
                <el-tab-pane label="分类管理" name="category">
                    <Category v-if="activeName=='category'"></Category>
                </el-tab-pane>
                <el-tab-pane label="设置" name="setting">
                    <Setting v-if="activeName == 'setting'"></Setting>
                </el-tab-pane>
                <el-tab-pane label="素材关联订单" name="order">
                    <Order v-if="activeName == 'order'"></Order>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Material from './material/Index.vue';
    import Category from './category/Index.vue';
    import Setting from './setting/Setting';
    import Order from './order/Order';
    export default {
        components: {
            Material,
            Category,
            Setting,
            Order,
        },
        data() {
          return {
              activeName: 'material',
              /*是否加载完成*/
              loading: true,
          }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/material/index.vue